<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{$t('Attribute_History')}}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">
      <!-- Added :key="componentKey" to force refresh -->
      <MySkills :key="componentKey" v-if="$store.state.traineeCoachAssignment.sidebarId !== 0"  />
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <!--<vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>-->
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('Cancel')}}</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import MySkills from '../trainee-skills/MySkills.vue'

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    }
  },
  components: {
    MySkills,
    VuePerfectScrollbar
  },
  data () {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      id: this.$store.state.traineeCoachAssignment.sidebarId,
      componentKey: 0 // <--- ADD THIS
    }
  },
  watch: {
    isSidebarActive (val) {
      if (val) {
        this.componentKey += 1 // <--- ADD THIS: Forces MySkills to mount fresh and pull the latest data
      }
      if (!val) return
      if (Object.entries(this.id).length === 0) {
        //this.initValues()
        //this.$validator.reset()
      } else {
        //const { category, id, img, name, order_status, price } = JSON.parse(JSON.stringify(this.data))
        //this.dataId = id
        //this.dataCategory = category
        //this.dataImg = img
        //this.dataName = name
        //this.dataOrder_status = order_status
        //this.dataPrice = price
        //this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          console.log("sidebar closed")
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      // if (this.id) return
      this.id = 0
    }
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
